/**
 * Safely converts any error value to a string for display
 * Handles Error objects, error objects with structure, and plain strings
 */
export function formatErrorForDisplay(error: unknown): string {
  if (error === null || error === undefined) {
    return 'An unknown error occurred';
  }
  
  // If it's already a string, return it
  if (typeof error === 'string') {
    return error;
  }
  
  // If it's an Error object, return the message
  if (error instanceof Error) {
    return error.message || 'An error occurred';
  }
  
  // If it's an object with an 'error' property (structured error from backend)
  if (typeof error === 'object' && error !== null) {
    const errorObj = error as Record<string, unknown>;
    
    // Check for structured error format: {row, row_data, field, error}
    if ('error' in errorObj && typeof errorObj.error === 'string') {
      const field = errorObj.field ? `Field: ${errorObj.field}. ` : '';
      const row = errorObj.row ? `Row: ${errorObj.row}. ` : '';
      return `${field}${row}${errorObj.error}`;
    }
    
    // Check for 'message' property
    if ('message' in errorObj && typeof errorObj.message === 'string') {
      return errorObj.message;
    }
    
    // Check for 'detail' property (FastAPI error format)
    if ('detail' in errorObj && typeof errorObj.detail === 'string') {
      return errorObj.detail;
    }
    
    // Last resort: try to stringify
    try {
      return JSON.stringify(error);
    } catch {
      return 'An error occurred';
    }
  }
  
  // For any other type, convert to string
  return String(error);
}

